import { Injectable } from '@angular/core';

/**
 * Lightweight service that lets the AI Assistant intercept navigation-like
 * actions (e.g. group switch) that would discard an active chat session.
 *
 * The assistant registers a callback via {@link registerGroupSwitchGuard};
 * consumers call {@link confirmGroupSwitch} before mutating the group.
 */
@Injectable({ providedIn: 'root' })
export class AssistantGuardService {
  private groupSwitchGuard: ((groupName: string) => Promise<boolean>) | null = null;

  registerGroupSwitchGuard(guard: (groupName: string) => Promise<boolean>): void {
    this.groupSwitchGuard = guard;
  }

  unregisterGroupSwitchGuard(): void {
    this.groupSwitchGuard = null;
  }

  /**
   * Returns `true` if the switch may proceed, `false` if the user cancelled.
   * When no guard is registered the switch is always allowed.
   */
  async confirmGroupSwitch(groupName: string): Promise<boolean> {
    if (!this.groupSwitchGuard) {
      return true;
    }
    return this.groupSwitchGuard(groupName);
  }
}
